import React from 'react';
import styled from 'styled-components';

import { ThemeContext } from './ThemeContext';

import { bpMaxXS } from '../utils/breakpoints';

const ToggleButton = styled.button`
	&.dark-mode-toggle {
		top: 8px;
		right: -12px;
		width: 24px;
		height: 24px;
		padding: 2px;
		overflow: hidden;
	}

	.light-theme-icon,
	.dark-theme-icon {
		top: 2px;
		width: 24px;
		height: 24px;
		position: absolute;
		transition: all 0.2s ease-in-out;
	}

	.light-theme-icon.active,
	.dark-theme-icon.active {
		opacity: 1;
		transform: scale(1);
	}

	.light-theme-icon.inactive {
		opacity: 0;
		transform: scale(0);
	}

	.dark-theme-icon.inactive {
		transform: scale(0);
		opacity: 0;
	}

	@media (min-width: 768px) {
		&.dark-mode-toggle {
			top: 4px;
			right: 0;
			width: 24px;
			height: 24px;
			padding: 6px;
			overflow: hidden;
		}

		.light-theme-icon,
		.dark-theme-icon {
			top: 6px;
			width: 24px;
			height: 24px;
			position: absolute;
			transition: all 0.2s ease-in-out;
		}
	}

	${bpMaxXS} {
		&.dark-mode-toggle {
			top: 0;
		}
	}
`;

const DarkModeToggle = () => {
	const { colorMode, setColorMode } = React.useContext(ThemeContext);

	const lightIconClass =
		colorMode === 'dark'
			? 'light-theme-icon active'
			: 'light-theme-icon inactive';

	const darkIconClass =
		colorMode === 'light'
			? 'dark-theme-icon active'
			: 'dark-theme-icon inactive';

	if (!colorMode) {
		return null;
	}

	const toggleTheme = () => {
		setColorMode(colorMode === 'dark' ? 'light' : 'dark');
	};

	return (
		<ToggleButton
			onClick={toggleTheme}
			aria-label="Toggle Theme"
			className="dark-mode-toggle absolute focus:outline-none"
		>
			<svg
				fill="currentColor"
				viewBox="0 0 20 20"
				className={lightIconClass}
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
					clipRule="evenodd"
				/>
			</svg>
			<svg
				className={darkIconClass}
				viewBox="0 0 20 20"
				fill="var(--dark-bg)"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
			</svg>
		</ToggleButton>
	);
};

export default DarkModeToggle;
